import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { LanguageService } from '../services/language.service';
import { DiscoveryStoreService } from '../services/discovery.service';

@Injectable({
  providedIn: 'root'
})
export class ConnectionService {
  companyName = '';
  httpsOptions = {
    headers: null,
    responseType: 'text' as 'text',
    withCredentials: true
  };

  constructor(private http: HttpClient, private langSvc: LanguageService, private discoveryService: DiscoveryStoreService) {
    this.httpsOptions.headers = new HttpHeaders({ 'Accept-Language': langSvc.getLocale() });
  }

  getFields(token) {
    return this.http.get(`${this.discoveryService.getAccountV2ApiEndpoint()}/driver/connection/configuration?token=${token}`, this.httpsOptions).pipe(
      map((resp: any) => {
        resp = JSON.parse(resp);
        this.companyName = resp.orgName;
        return resp;
      }),
      catchError(() => {
        return of({});
      })
    );
  }

  getTermsContent(link) {
    return this.http.get(link, this.httpsOptions).pipe(
      map((resp) => {
        return resp.replace(/<script[^>]*?>.*?<\/script>/gi, '');
      })
    );
  }

  /**
   * web-driver parity: fetch a connection's details by companyId (the `connection=<id>` URL param),
   * mirroring web-driver's ConnectionService.getConnectionInfo → GET {accountV2}/driver/connection/info?companyId=.
   * Requires the driver session (present after account creation), sent via withCredentials.
   */
  getConnectionInfo(companyId) {
    return this.http.get(`${this.discoveryService.getAccountV2ApiEndpoint()}/driver/connection/info?companyId=${companyId}`, this.httpsOptions).pipe(
      map((resp: any) => JSON.parse(resp)),
      catchError(() => {
        return of({});
      })
    );
  }

  /**
   * Request a connection AFTER the account has been created (separate authenticated call,
   * mirroring web-driver's ConnectionService.requestConnection → POST {accountV2}/driver/connection/).
   * Sent with the driver's session cookie (withCredentials). Prefers companyId (web-driver parity)
   * and falls back to the invite token when the configuration response has no companyId.
   */
  requestConnection(payload: { companyId: number; connectionFields: any[] }) {
    return this.http.post(
      `${this.discoveryService.getAccountV2ApiEndpoint()}/driver/connection/`,
      { companyId: payload.companyId, connectionFields: payload.connectionFields },
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Accept-Language': this.langSvc.getLocale()
        }),
        withCredentials: true,
        responseType: 'text'
      }
    );
  }
}
